export const MFA_METHODS = {
  SOFTWARE_TOKEN_MFA: "SOFTWARE_TOKEN_MFA",
  EMAIL_MFA: "EMAIL_MFA",
  SMS_MFA: "SMS_MFA",
};

export const MFA_LABELS = {
  SOFTWARE_TOKEN_MFA: "Authenticator app",
  EMAIL_MFA: "Email",
  SMS_MFA: "SMS",
};

export const LOCATION_TYPES = [
  { key: "Headquarters", value: "Headquarters" },
  { key: "Corporate_Office", value: "Corporate Office" },
  { key: "store", value: "Store" },
];

export const LOCATION_S3_FOLDER = "/images/company-location-logos";
export const MAX_LOCATION_LOGO_SIZE_MB = 2;
